<section class="page-wrapper scroll-container">
  <div class="d-flex flex-column justify-content-center align-items-center h-100">
    <a *ngFor="let info of portalInfo" class="landing-button mb-3" [href]="info.Url">
      <div>
        {{ info.DisplayName }}
      </div>
    </a>
  </div>
</section>
